export enum AccountUpdateType {
    UNDEFINED = 0,
    PERSONAL = 1,
    SECURITY = 2
}